import { optionSubcategory_mobile } from './mobileSubCategory.locstring.json';
import { MobileDeviceOption, initMobileDeviceFullOption } from 'owa-mobile-option';
import { OptionSubCategory } from 'owa-options-core';

let mobileSubCategory: OptionSubCategory = {
    key: 'mobile',
    titleStringKey: optionSubcategory_mobile,
    options: [MobileDeviceOption],
    onSelected: async () => await initMobileDeviceFullOption(),
};

export default mobileSubCategory;
